var render = function (_h,_vm) {var _c=_vm._c;return _c('hr',{staticClass:"obj-divider"})}
var staticRenderFns = []

export { render, staticRenderFns }